export const ADMIN_UI_LANGUAGE_STORAGE_KEY = "intelligo.admin.language.ui";
export const VIEW_TRANSLATIONS_UI_LANGUAGE_STORAGE_KEY = "intelligo.view.language.ui";
export const VIEW_TRANSLATIONS_CONTENT_LANGUAGE_STORAGE_KEY = "intelligo.view.language.content";
